<template>
  <div class="signup-success">
    <h1>🎉 お申し込みありがとうございます！</h1>
    <p>ご登録のメールアドレス宛に、パスワード設定用の招待メールを送信しました。</p>
    <p>メール内のリンクからパスワードを設定すると、ログインできるようになります。</p>
    <div class="actions">
      <router-link to="/">トップページへ戻る</router-link>
    </div>
  </div>
  
</template>

<script setup>
</script>

<style scoped>
.signup-success {
  max-width: 640px;
  margin: 2rem auto;
  padding: 0 1rem;
  text-align: center;
}
.actions { margin-top: 1rem; }
a { color: #635bff; text-decoration: underline; }
</style>


